import * as Redux from 'redux';
import { LoadStudiesAction } from './CoreActions';
import { WebPortalClient } from 'webportalclient';
import { User } from '../misc/api/apiTypes';

export enum SecurityActionType {
    GetStudy = 'GetStudy',
    MultiStudiesWarning = 'MultiStudiesWarning',
    NoStudiesWarning = 'NoStudiesWarning',
    LoadCurrentUser = "LoadCurrentUser",
}

declare const rootUrl: string;

export class GetStudyAction implements Redux.Action {
    type: SecurityActionType.GetStudy;
    studyId: string;

    static create(studyId: string): GetStudyAction {
        return {
            type: SecurityActionType.GetStudy,
            studyId: studyId,
        }
    }
}

export class MultiStudiesWarningAction implements Redux.Action {
    type: SecurityActionType.MultiStudiesWarning;
     
    static create(): MultiStudiesWarningAction {
        return {
            type: SecurityActionType.MultiStudiesWarning,
        }
    }
}

export class NoStudiesWarningAction implements Redux.Action {
    type: SecurityActionType.NoStudiesWarning;

    static create(): NoStudiesWarningAction {
        return {
            type: SecurityActionType.NoStudiesWarning,
        }
    }
}

export class LoadCurrentUserAction implements Redux.Action {
    type: SecurityActionType.LoadCurrentUser;
    user: User;

    static create(user: User): LoadCurrentUserAction {
        return {
            type: SecurityActionType.LoadCurrentUser,
            user: user,
        }
    }
}

export type SecurityAction = MultiStudiesWarningAction | GetStudyAction | NoStudiesWarningAction | LoadCurrentUserAction;
